module.exports = __webpack_public_path__ + "img/order-active.a3d06779.svg";